import type { TOptions } from "i18next";
import React from "react";
import type { ReactElement, ReactNode } from "react";
import { Trans as ReactI18nextTrans } from "react-i18next";

type TransProps = {
  children?: ReactNode;
  components?: Record<string, ReactElement> | ReactElement[];
  i18nKey: string;
  namespace?: string;
  tOptions?: TOptions;
  values?: Record<string, unknown>;
};

/**
 * Custom Trans component that wraps react-i18next's Trans component
 * Use this for complex translations with HTML elements, links, or formatting
 */
export const Trans = ({
  children,
  components = {},
  i18nKey,
  namespace,
  tOptions = {},
  values = {},
}: TransProps) => {
  const handleMissingTranslation = (key: string, defaultValue: unknown) =>
    defaultValue || children || key;

  return (
    <ReactI18nextTrans
      components={components}
      i18nKey={i18nKey}
      ns={namespace}
      values={values}
      tOptions={{
        defaultValue: handleMissingTranslation(i18nKey, tOptions.defaultValue),
        ...tOptions,
      }}
    >
      {children}
    </ReactI18nextTrans>
  );
};
